import { render, staticRenderFns } from "./DashboardCalendar.vue?vue&type=template&id=78b0647c&scoped=true"
import script from "./DashboardCalendar.vue?vue&type=script&lang=ts"
export * from "./DashboardCalendar.vue?vue&type=script&lang=ts"
import style0 from "./DashboardCalendar.vue?vue&type=style&index=0&id=78b0647c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b0647c",
  null
  
)

export default component.exports